// #region Global Imports
import React from 'react';
// #endregion Global Imports
// #region Local Imports
import { gql } from '@generated/gql';
import type { IProps } from '@components/Paragraphs/ParagraphSmallText/ParagraphSmallText';
import { getFragmentData } from '@generated/fragment-masking';
import styles from './ParagraphSmallText.module.sass';
// #endregion Local Imports

export const ParagraphSmallTextFragment = gql(/* GraphQL */ `
  fragment ParagraphSmallTextFragment on ParagraphSmallText {
    smallTextText: fieldText {
      processed
    }
  }
`);

export const ParagraphSmallText: React.FunctionComponent<
  IProps.ParagraphSmallText
> = ({ paragraph: _paragraph }) => {
  const paragraph = getFragmentData(ParagraphSmallTextFragment, _paragraph);
  return (
    <div className={styles.ParagraphSmallText__root}>
      <div
        dangerouslySetInnerHTML={{
          __html: String(paragraph.smallTextText?.processed),
        }}
      />
    </div>
  );
};
